import Modal from './Modal';

export * from './Modal.types';
export default Modal;
